import React, { Component } from 'react';
import TextField from '@mui/material/TextField';
import SendIcon from '@mui/icons-material/Send';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import authStore from '../../Auth/AuthStore'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import mainStore from '../../../MainStore';

export default class SaleCommentBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comment: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentWillMount() {
        let scope = this;
        mainStore.setMaskVisible();
        fetch('api/Sale/GetComment?saleId=' + this.props.saleId, {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    scope.setState({ comments: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleChange = name => evt => {
        this.setState({[name]: evt.target.value});
    }

    handleSave() {
        var scope = this;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Sale/AddComment', {
            method: 'POST',
            body: JSON.stringify({ Text: this.state.comment, WorkId: this.props.saleId }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    var comments = scope.state.comments;
                    comments.push(result);
                    mainStore.setMaskUnvisible();
                    scope.setState({ comments: comments, comment: '' });
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        var comments = this.state.comments && this.state.comments.map(c =>
            <Card fullWidth className="comment-card">
                <CardContent>
                    <Typography color="textSecondary" gutterBottom>
                        {c.userName} at {c.date}
                    </Typography>
                    <Typography variant="body2" component="p">
                        {c.text}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Button size="small">Edit</Button>
                </CardActions>
            </Card>);
        return (
            <div className="full-width">
                <div className="fixed-heigth">
                    {comments}
                </div>

                <TextField required
                    id="standard-required"
                    label="Новый комментарий"
                    fullWidth
                    margin="normal"
                    value={this.state.comment}
                    multiline
                    onChange={this.handleChange('comment')}
                    onKeyDown={(e) => e.keyCode === 13 && e.ctrlKey && this.handleSave()}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton size="small" onClick={this.handleSave}>
                                    <SendIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
        );
    }
}
